module.exports = __webpack_public_path__ + "img/ums-resource.a6e88d68.svg";